module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/o4Uqnv/images/cover.jpg?1700065770827",
      "alt": "This image is the cover for the book Martinsville, Postcard History"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Martinsville, Postcard History\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Based on vintage postcards, this new book is a unique and welcome addition to the small number of works devoted to the history of Martinsville. Captured here in more than 220 postcard images is an important chronicle of the past 100 years in the �City of Mineral Water.� This visual record showcases the sanitariums�including the glorious Home Lawn and its sibling, the Martinsville�industries and businesses, buildings and people, courthouse square, and special events that shaped the past and influenced the present. This fascinating retrospective is an indispensable companion to and expansion of Morgan County, the authors� first book in Arcadia�s Postcard History Series.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Joanne Raetz Stuttgen, Curtis Tomak\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Joanne Raetz Stuttgen is a folklorist and cultural resources specialist active in local history research and historic preservation. Curtis Tomak, an archaeologist with the State of Indiana, is an avid collector of vintage postcards and local memorabilia.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Arcadia Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0